// FIN-HUBS: DRE & Resultado — DRE + Orçamento + Lançamentos + Rateio Clockify.
import { useEffect, useState } from 'react';
import { Spin, Alert } from 'antd';
import HubAbas, { HubTab } from '../../components/HubAbas';
import Dashboard from '../Dashboard';
import Orcamento from '../Orcamento';
import LancamentosManuais from '../LancamentosManuais';
import RateioMensalClockify from '../RateioMensalClockify';
import InsightsDRE from '../financeiro-insights/InsightsDRE';
import MetaPremio from '../MetaPremio';
import BalancoPatrimonial from '../BalancoPatrimonial';
import ResultadoContratos from '../ResultadoContratos';
import AlocacaoPadrao from '../financeiro-fechamento/AlocacaoPadrao';

// PROVISÓRIO (Lucas 2026-07-16): calculadora standalone de Lucro Presumido
// (HTML autocontido em public/ferramentas/). O CloudFront manda
// X-Frame-Options: DENY em tudo, então iframe por URL é bloqueado — o fix é
// buscar o HTML e injetar via srcDoc (documento inline não passa pela
// navegação de rede, o header não se aplica).
function CalculadoraLP() {
  const [html, setHtml] = useState<string | null>(null);
  const [erro, setErro] = useState(false);
  useEffect(() => {
    fetch('/ferramentas/calculadora-lucro-presumido.html')
      .then(r => { if (!r.ok) throw new Error(); return r.text(); })
      .then(setHtml)
      .catch(() => setErro(true));
  }, []);
  if (erro) return <Alert type="error" message="Não consegui carregar a calculadora" style={{ margin: 24 }} />;
  if (html == null) return <div style={{ padding: 60, textAlign: 'center' }}><Spin /></div>;
  return (
    <iframe srcDoc={html} title="Calculadora Lucro Presumido"
      style={{ width: '100%', height: 'calc(100vh - 150px)', border: 'none', display: 'block' }} />
  );
}

const TABS: HubTab[] = [
  { key: 'dre',             label: '📊 DRE',              perm: 'financeiro.dre.ver',             render: () => <Dashboard user={null} signOut={() => {}} /> },
  { key: 'insights',        label: '📈 Insights',         perm: 'financeiro.dre.ver',             render: () => <InsightsDRE /> },
  // FECHAMENTO-CC (2026-08-17): lucro real por contrato, da decomposição da DRE
  { key: 'contratos',       label: '💰 Por contrato',     perm: 'financeiro.dre.ver',             render: () => <ResultadoContratos /> },
  { key: 'mao-obra',        label: '👷 Mão de obra',      perm: 'financeiro.dre.ver',             render: () => <AlocacaoPadrao /> },
  // META-PREMIO (2026-07-16): visível a todos — perm seeded a todos os perfis
  { key: 'meta',            label: '🎯 Meta & Prêmio',    perm: 'financeiro.meta.ver',            render: () => <MetaPremio /> },
  // BALANCO (2026-07-17): foto mensal gerencial + ponte lucro→caixa (didático)
  { key: 'balanco',         label: '🏦 Balanço',          perm: 'financeiro.dre.ver',             render: () => <BalancoPatrimonial /> },
  { key: 'calc-lp',         label: '🧮 Calculadora LP',   perm: 'financeiro.dre.ver',             render: () => <CalculadoraLP /> },
  { key: 'orcamento',       label: 'Orçamento',           perm: 'financeiro.orcamento.ver',       render: () => <Orcamento /> },
  { key: 'lancamentos',     label: 'Lançamentos',         perm: 'financeiro.lancamentos.ver',     render: () => <LancamentosManuais /> },
  { key: 'rateio-clockify', label: '⏱️ Rateio Clockify (legado)',  perm: 'financeiro.rateio_clockify.ver', render: () => <RateioMensalClockify /> },
];

export default function FinanceiroDreHub() {
  return <HubAbas tabs={TABS} />;
}
